module.exports = __webpack_public_path__ + "static/media/CTLI_6-235w.e6e59b71.webp";